import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/reports/balanceHistory/filter'; // Importing Filter component
import Table from 'views/reports/balanceHistory/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the balance history view.
 * @extends JetView
 */
export default class balanceHistoryView extends JetView {
    /**
     * Configures the UI components of the balance history view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const vthis = this; // Reference to the current view instance
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                // Columns within the toolbar
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100', '1000', '10000'], // Options for page size
                    width: 70, // Width of the dropdown
                    on: {
                        // Event handlers
                        onChange: function () {
                            // Change event for page size
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from configuration
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export', // Name of the export dropdown
                    id: 'Export', // Unique identifier for the export dropdown
                    width: 120, // Width of the dropdown
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Export options
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        // Event handlers
                        onChange: function (value) {
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // Calculate first item index
                            var last = first + size - 1; // Calculate last item index
                            if (value !== '') {
                                vthis.app.callEvent('export:filter', [
                                    { value: value, first: first, last: last }, // Trigger export event
                                ]);
                            }
                        }, // Bind context to the function
                    },
                },
            ],
        };
        const left = {
            rows: [
                // Left section of the layout
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Apply current theme
                    elements: [
                        // Elements in the toolbar
                        { view: 'label', label: _('Historial de saldo') }, // Title label
                        {
                            type: 'wide', // Wide button type
                            css: 'close-bottom', // CSS class for styling
                            id: 'button-search', // Unique identifier for the search button
                            cols: [
                                // Columns within the button
                                {
                                    view: 'icon', // Icon button for search
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => {
                                        // Click event for the icon
                                        $$('filterPopup').show(); // Show filter popup
                                    },
                                },
                            ],
                        },
                    ],
                },
                Filter, // Include Filter component
                Table, // Include Table component
                toolbar, // Include toolbar
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5', // Unique identifier for the form
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            rows: [
                // Rows in the form
                {
                    responsive: 'a5', // Responsive design for the form
                    type: 'wide', // Wide type for the layout
                    cols: [left], // Include left section
                },
            ],
        };
    }

    /**
     * Initializes the balance history view.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500 || screen.height < 500) {
                // Check for small screen size
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove the export dropdown
                $$('pagerA').define('group', 1); // Define pager group
            }
            if (screen.width > 500 && screen.height > 500) {
                // Check for larger screen size
                $$('button-search').hide(); // Hide search button
            }
            $.fn.scrollBottom = function () {
                // Add scrollBottom function to jQuery
                return $$(document).height() - this.scrollTop() - this.height(); // Calculate scroll bottom position
            };
        });
    }
}

// FILE DOCUMENTED
